// extracted by mini-css-extract-plugin
module.exports = {"button":"qdO4vH","hoverButton":"_1EDaV7","watchlistWrapper":"_3lt4hS","watchlistButton":"_3xbRRK"};